import React from 'react';

import { Container, Description } from './styles';

import { MdWarning } from "react-icons/md";

const Error = ({ children, description, ...rest }) => (
  <Container {...rest}>
    <MdWarning color="#e00000" size={20} /><Description>{description}</Description>
  </Container>
);

export default Error;